import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";
import { Container } from "./styles";

export type TotalProps = {
  total: number;
};

const Total: React.FC<TotalProps> = ({ total }) => {
  const { locale = "it" } = useRouter();
  const label = useTranslation("newsPage.countLabel", locale) || "notizie";

  return (
    <Container>
      {total} {label}
    </Container>
  );
};

export default Total;
